const triggers = document.querySelectorAll('[data-trigger-item]');
const results = document.querySelectorAll('[data-target-result]');
let historyStack = [];

const triggerChangeElement1 = document.querySelectorAll('[data-trigger-change-1]');
const triggerChangeHokkaidoContractElements = document.querySelectorAll('[data-trigger-change-hokkaido-contract]');
const triggerChangeTohokuContractElements = document.querySelectorAll('[data-trigger-change-tohoku-contract]');

// 最初の質問で北海道電力か東北電力を選ぶかで遷移先を変更する
document.querySelectorAll('.-hokkaido, .-tohoku').forEach((radio) => {
    radio.addEventListener('change', (e) => {
        if (e.target.checked) {
            const isHokkaido = e.target.classList.contains('-hokkaido');
            const isTohoku = e.target.classList.contains('-tohoku');

            triggerChangeElement1.forEach((element) => {
                if (isHokkaido) {
                    element.setAttribute('data-trigger-item', 'hokkaido');
                } else if (isTohoku) {
                    element.setAttribute('data-trigger-item', 'tohoku');
                }
            });
        }
    });
});

// 北海道2番目でどちらを選ぶかで遷移先を変更する
document.querySelectorAll('.-hokkaido-b, .-hokkaido-c').forEach((radio) => {
    radio.addEventListener('change', (e) => {
        if (e.target.checked) {
            const isHokkaidoB = e.target.classList.contains('-hokkaido-b');
            const isHokkaidoC = e.target.classList.contains('-hokkaido-c');

            triggerChangeHokkaidoContractElements.forEach((element) => {
                if (isHokkaidoB) {
                    element.setAttribute('data-trigger-item', 'hokkaido-capacity-b');
                } else if (isHokkaidoC) {
                    element.setAttribute('data-trigger-item', 'hokkaido-capacity-c');
                }
            });
        }
    });
});

// 東北2番目でどちらを選ぶかで遷移先を変更する
document.querySelectorAll('.-tohoku-b, .-tohoku-c').forEach((radio) => {
    radio.addEventListener('change', (e) => {
        if (e.target.checked) {
            const isTohokuB = e.target.classList.contains('-tohoku-b');
            const isTohokuC = e.target.classList.contains('-tohoku-c');

            triggerChangeTohokuContractElements.forEach((element) => {
                if (isTohokuB) {
                    element.setAttribute('data-trigger-item', 'tohoku-capacity-b');
                } else if (isTohokuC) {
                    element.setAttribute('data-trigger-item', 'tohoku-capacity-c');
                }
            });
        }
    });
});

triggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        let value = e.currentTarget.getAttribute('data-trigger-item');
        const currentItem = e.currentTarget.closest('[data-target-hidden]');

        if (currentItem) {
            historyStack.push(currentItem);
        }

        if (value === 'hokkaido-result' || value === 'tohoku-result') {
            window.location.href = '/consumer/kitaden/rate-simulation/result';
            return;
        }

        const targetItem = document.querySelector(`[data-target-item='${value}']`);
        if (targetItem) {
            targetItem.classList.add('is-show');
        }
        if (value === 'hokkaido' || value === 'tohoku') {
            hideAllItemsExcept(value);
        }
        e.currentTarget.closest('[data-target-hidden]').classList.remove('is-show');
    });
});

const backButtons = document.querySelectorAll('[data-trigger-back]');
backButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
        e.preventDefault();
        if (historyStack.length > 0) {
            const previousItem = historyStack.pop();
            if (previousItem) {
                const currentItem = e.currentTarget.closest('[data-target-item]');
                if (currentItem) {
                    currentItem.classList.remove('is-show');
                }
                previousItem.classList.add('is-show');
            }
        }
    });
});

function hideAllItemsExcept(area) {
    const allItems = document.querySelectorAll('[data-target-item]');
    allItems.forEach((item) => {
        if (!item.getAttribute('data-target-item').startsWith(area)) {
            item.classList.remove('is-show');
        }
    });
}

function resetAll() {
    const allItems = document.querySelectorAll('[data-target-item]');
    allItems.forEach((item) => item.classList.remove('is-show'));
    results.forEach((result) => result.classList.remove('is-show'));
    document.querySelector("[data-target-item='start']").classList.add('is-show');
    historyStack = [];
}

document.querySelectorAll('.kitaden-top__area-btn').forEach((button) => {
    button.addEventListener('click', (event) => {
        const classList = event.target.classList;
        if (classList.contains('-hokkaido')) {
            sessionStorage.setItem('selectedArea', 'hokkaido-area');
        } else if (classList.contains('-tohoku')) {
            sessionStorage.setItem('selectedArea', 'tohoku-area');
        }
    });
});
